import { render, staticRenderFns } from "./RatingFeedback.vue?vue&type=template&id=7be1a863&scoped=true"
import script from "./RatingFeedback.vue?vue&type=script&lang=js"
export * from "./RatingFeedback.vue?vue&type=script&lang=js"
import style0 from "./RatingFeedback.vue?vue&type=style&index=0&id=7be1a863&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be1a863",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be1a863')) {
      api.createRecord('7be1a863', component.options)
    } else {
      api.reload('7be1a863', component.options)
    }
    module.hot.accept("./RatingFeedback.vue?vue&type=template&id=7be1a863&scoped=true", function () {
      api.rerender('7be1a863', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feedback/RatingFeedback.vue"
export default component.exports